export default __webpack_public_path__ + "images/responded-circle-icon.205727d078aab8ad8f4bb01d1834ed00.svg";